import {
  Directive,
  ElementRef,
  Host,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appPortalRender]',
})
export class PortalRenderDirective implements OnChanges, OnDestroy {
  @Input('appPortalRender')
  container: Element;

  private transferSubscription: Subscription;

  constructor(
    @Host() private elementRef: ElementRef<any>,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.container) {
      this.transferSubscription?.unsubscribe();

      const container = this.container;
      if (container) {
        const child = this.elementRef.nativeElement;
        this.renderer.appendChild(container, child);

        this.transferSubscription = new Subscription(() => {
          this.renderer.removeChild(container, child, true);
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.transferSubscription?.unsubscribe();
  }
}
